// extracted by mini-css-extract-plugin
export default {"root":"IconPickup_root__CBCiK"};